// extracted by mini-css-extract-plugin
export default {"editor":"TipTapEditor_editor__qmy-P"};